import React from 'react';
import { useEffect, useState } from "react";

import { Container } from 'react-bootstrap';
import { useLocation } from "react-router-dom";

// import Breadcrumbs from '../components/Breadcrumbs';
import FundSchemes from '../features/schemes/FundSchemes';

export default function UserFundSchemes2({ filters = []}) {
  const location = useLocation();
  const [fundSchemesURL, setFundSchemesURL] = useState('/my-fund-schemes');

  const watchlistParam = (location.state?.watchlistName) ? {'watchlistName' : (location.state?.watchlistName) }: null

  useEffect(() => {
    if (!watchlistParam) {
      setFundSchemesURL('/my-fund-schemes');
      return;
    }
    setFundSchemesURL('/my-fund-schemes');
    return;
  }, []);

  return (
    <div className="container-fluid" >
      <FundSchemes urlParams={watchlistParam} apiURL={fundSchemesURL} filters={filters} 
                     schemeListTitle="Tracked Schemes in User Selected Funds"/>
    </div>
  );
}